module.exports = __webpack_public_path__ + "img/pic_qudao.c7f48741.png";